import React, { useState,useEffect,useRef } from "react"
import { Button, Card, Container, Row, Col, Modal, Form } from "react-bootstrap"
import { FaPhone,FaHeart,FaEye, FaBullseye, FaClock, FaShieldAlt, FaUsers, FaStar, FaArrowRight, FaCheckCircle, FaCar, FaTimes,FaWhatsapp,FaFacebook,FaInstagram,FaTwitter,FaLinkedin,FaEnvelope,FaYoutube } from "react-icons/fa"
import { Link } from "react-router-dom"
import api from "../../services/api"
import emailjs from "emailjs-com";
import Footer from "./Footer"
import PatientRegister from "../patient/PatientRegister"

export default function HomePage() {
  const videoRef = useRef(null);
    const [isMuted, setIsMuted] = useState(true)
  const [showDriverModal, setShowDriverModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [driverForm, setDriverForm] = useState({
    name: '',
    phone_number:'',
    car_name: '',
    engine_capacity: '',
    car_model_year: '',
    images: []
  });

useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = true // start muted
      videoRef.current.play().catch(() => {})
      
    }
  }, [])

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted
      setIsMuted(videoRef.current.muted)
    }
  }



  const handleDriverSubmit = async (e) => {
    e.preventDefault();
    
    // Client-side validation
    if (!driverForm.name || !driverForm.car_name || !driverForm.engine_capacity || !driverForm.car_model_year ) {
      alert('Please fill in all required fields and upload at least one image.');
      return;
    }
    const phoneRegex = /^03\d{9}$/;
    if (!phoneRegex.test(driverForm.phone_number)) {
      alert('Please enter a valid phone number (format: 03XXXXXXXXX)');
      return;
    }
    
    // Validate car model year based on engine capacity
    const year = parseInt(driverForm.car_model_year);
    const minYear = driverForm.engine_capacity === '660cc' ? 2020 : 
                   driverForm.engine_capacity === '1000cc' ? 2018 : 
                   driverForm.engine_capacity === '1300cc' ? 2016 : 
                   driverForm.engine_capacity === '1500cc' ? 2015 : 
                   driverForm.engine_capacity === '1800cc' ? 2015 : 2020;
    
    if (year < minYear || year > 2024) {
      alert(`Car model year must be between ${minYear} and 2025 for ${driverForm.engine_capacity} engine capacity.`);
      return;
    }
    
    setLoading(true);
    
    try {
       const templateParams = {
      name: driverForm.name,
      car_name: driverForm.car_name,
      engine_capacity: driverForm.engine_capacity,
      car_model_year: driverForm.car_model_year,
      phone_number: driverForm.phone_number,
    };

    await emailjs.send(
      "service_jgqwa4p",   // from EmailJS dashboard
      "template_w41jgq6",  // from EmailJS dashboard
      templateParams,
      "deagsR6UbjmOIKT9R"    // from EmailJS dashboard
    ) .then((response) => {
    console.log("SUCCESS!", response.status, response.text);
  })
  .catch((err) => {
    console.error("FAILED...", err);
  });

    // alert('Driver registration successful! We will contact you soon.');
    //  setShowDriverModal(false);
    // setDriverForm({
    //           name: '',
    //           car_name: '',
    //           engine_capacity: '',
    //           car_model_year: '',
    //           phone_number: '',
    //           images: []
    //         });

      // Create FormData for file uploads
      const formData = new FormData();
      formData.append('name', driverForm.name);
      formData.append('car_name', driverForm.car_name);
      formData.append('engine_capacity', driverForm.engine_capacity);
      formData.append('car_model_year', driverForm.car_model_year);
      formData.append('phone_number', driverForm.phone_number);
      // Append images
      if (driverForm.images.length > 0) {
        driverForm.images.forEach((image, index) => {
          formData.append('images', image);
        });
      }
      
      const response = await api.registerDriver(formData);
      
      if (response.success) {
        alert('Driver registration successful! We will contact you soon.');
        setShowDriverModal(false);
        setDriverForm({
          name: '',
          car_name: '',
          engine_capacity: '',
          car_model_year: '',
          phone_number: '',
          images: []
        });
      }
    } catch (error) {
      alert('Registration failed: ' + (error.message || 'Something went wrong'));
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="min-vh-100  overflow-hidden">
      {/* Hero Section */}
    <section
  className="position-relative overflow-hidden"
  style={{
    minHeight: "100vh",
  }}
>
  {/* Background Video */}
  <div
    style={{
      position: "absolute", // absolute so it stays inside section
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: 0,
      overflow: "hidden"
    }}
  >
    <video
      ref={videoRef}
      autoPlay
      loop
      muted
      playsInline
      className="w-100 h-100"
      style={{
        objectFit: "cover",
        filter: "brightness(0.3)",
      }}
    >
      <source src="/video/background-video2.mp4" type="video/mp4" />
    </video>
  </div>

  {/* Overlay */}
  <div 
    className="position-absolute w-100 h-100"
    style={{
      background: "transparent",
      zIndex: 1,
    }}
  ></div>

        <Container className="position-relative" style={{ zIndex: 2 }}>
          <Row className="align-items-center min-vh-100 py-5">
            <Col lg={6}>
              <div className="text-white mb-4">
                <div
                  className="d-inline-flex align-items-center px-4 py-2 rounded-pill mb-4"
                  style={{
                    backgroundColor: "transparent",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                  }}
                >
                  <FaCheckCircle className="me-2" />
                  <span className="fw-medium">Trusted by 50,000+ Patients</span>
                </div>

                <h1 className="display-2 fw-bold mb-4" style={{ lineHeight: "1.1" }}>
                  Your Health,
                  <br />
                  <span
                    style={{
                      background: "linear-gradient(135deg, #a7f3d0 0%, #6ee7b7 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                    }}
                  >
                    Our Priority
                  </span>
                </h1>

                <p className="fs-5 mb-5 opacity-90" style={{ lineHeight: "1.6" }}>
                  Aidify is a patient-centric healthcare services company dedicated to streamlining access to quality medical care.
                  <span style={{fontWeight:700}}> From doctor appointment to patient pick and drop.</span>
                </p>
<div className="container">
  <div className="row g-3 justify-content-center mb-5">

    <div className="col-12 col-md-6 d-flex justify-content-center gap-3 flex-wrap">
        {/* Phone Button */}
      <Button
        as="a"
        href="tel:+923001243439"
        size="lg"
        className="w-100 w-md-auto px-4 py-2 rounded-pill fw-bold border-0 d-flex align-items-center justify-content-center"
        style={{
          background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
          boxShadow: "0 8px 25px rgba(8, 145, 178, 0.4)",
          color: "#fff",
        }}
      >
        <FaPhone className="me-2" />
        +92 300 1243439
      </Button>
      
      {/* Book Appointment */}
      <Button
        size="lg"
        className="w-100 w-md-auto px-4 py-2 fw-bold shadow d-flex align-items-center justify-content-center"
        style={{
          borderRadius: "30px",
          background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
          border: "none",
          color: "#fff",
        }}
        onClick={() => {
            if (window.fbq) {
      window.fbq("track", "Clicked Book Appointment"); 
    }
          setShowAppointmentModal(true)}}
      >
        Book Appointment
      </Button>
    </div>

                   

    <div className="col-12 col-md-6 d-flex justify-content-center gap-3 flex-wrap">
      {/* WhatsApp Button */}
      <Button
        as="a"
        href="https://wa.me/923001243439"
        target="_blank"
        rel="noopener noreferrer"
        size="lg"
        className="w-100 w-md-auto px-4 py-2 rounded-pill fw-bold border-0 d-flex align-items-center justify-content-center"
        style={{
          background: "linear-gradient(135deg, #25d366 0%, #128c7e 100%)",
          boxShadow: "0 8px 25px rgba(18, 140, 126, 0.4)",
          color: "#fff",
        }}
      >
        <FaWhatsapp className="me-2" />
        +92 300 1243439
      </Button>

      {/* Register Driver */}
      <Button
        size="lg"
        variant="outline-light"
        className="w-100 w-md-auto px-4 py-2 rounded-pill fw-bold d-flex align-items-center justify-content-center"
        style={{
          borderWidth: "2px",
          backdropFilter: "blur(10px)",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          // color: "#0891b2",
          // borderColor: "#0891b2",
        }}
        onClick={() => setShowDriverModal(true)}
      >
        Register as Driver
      </Button>
    </div>
  </div>
</div>


                <div className="d-flex gap-4 opacity-90">
                  {[
                    { icon: FaClock, text: "24/7 Available" },
                    { icon: FaShieldAlt, text: "Secure & Private" },
                    { icon: FaUsers, text: "500+ Drivers" },
                  ].map(({ icon: Icon, text }, index) => (
                    <div key={index} className="d-flex align-items-center">
                      <div
                        className="rounded-circle me-2 d-flex align-items-center justify-content-center"
                        style={{
                          width: "35px",
                          height: "35px",
                          backgroundColor: "rgba(255, 255, 255, 0.2)",
                          backdropFilter: "blur(10px)",
                        }}
                      >
                        <Icon size={14} />
                      </div>
                      <span className="fw-medium">{text}</span>
                     
                    </div>
                  ))}
   
                </div>
                 {/* Volume Button */}
                   <Button
      variant="light"
      onClick={toggleMute}
      style={{
        // position: "sticky",
        bottom: "-70px",
        right: "20px",
        borderRadius: "50%",
        width: "50px",
        height: "50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop:"20px",
      }}
    >
      {isMuted ? "🔇" : "🔊"}
    </Button>
              </div>
            </Col>
            
  
          </Row>
        </Container>
      </section>

      {/* Emergency Contact Section */}
      <section
        className="py-4 position-relative overflow-hidden"
        style={{
          background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
        }}
      >
        <Container>
          <div className="text-center text-white">
            <div className="d-flex align-items-center justify-content-center mb-3">
              <div>
                <h2 className="h4 fw-bold mb-1">Need Medical Attention?</h2>
                <p className="mb-0 opacity-90">
                  Call us immediately and we'll connect you with the right doctor within 2 to 3 days
                </p>
              </div>
            </div>
<Button
  variant="success"
  size="lg"
  className="px-4 py-2 fw-bold shadow rounded-pill mb-4"
  style={{
    background: "transparent",
    border: "1px solid #ffffff",
  }}
  onClick={() => setShowAppointmentModal(true)}
>
  Book Your Appointment Now
</Button>
           
          </div>
        </Container>
      </section>

      {/* Features Section */}
      <section className="py-5" style={{ backgroundColor: "#f8fffe" }}>
        <Container>
          <div className="text-center mb-5">
             <a href="tel:+923001243439">
  <Button
    size="lg"
    variant="light"
    className="px-5 py-3 rounded-pill fw-bold mb-4"
    style={{
      background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
      transform: "translateY(0)",
      transition: "all 0.3s ease",
    }}
    onMouseEnter={(e) => {
      e.target.style.transform = "translateY(-3px)"
      // e.target.style.boxShadow = "0 12px 35px rgba(0, 0, 0, 0.3)"
    }}
    onMouseLeave={(e) => {
      e.target.style.transform = "translateY(0)"
      // e.target.style.boxShadow = "0 8px 25px rgba(0, 0, 0, 0.2)"
    }}
  >
    <FaPhone className="me-2" style={{ color: "white" }} />
    <span style={{ color: "white" }}>Call: +92 300 1243439</span>
  </Button>
</a>
           


            <h2 className="display-5 fw-bold mb-4" style={{ color: "#1f2937" }}>
              Why Choose Aidify?
            </h2>
            <p className="fs-5 text-muted mb-0" style={{ maxWidth: "600px", margin: "0 auto" }}>
              We provide seamless Aidify connections with experienced professionals
            </p>
          </div>

          <Row className="g-4">
            {[
              {
                icon: FaClock,
                title: "Appointment Scheduling",
                description:
                  " Convenient appointment booking within 3 working days.",
                gradient: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                delay: "0s",
              },
              {
                icon: FaUsers,
                title: "Transportation Services",
                description:
                  "Timely pick-up and drop-off of patients from their homes to doctor's clinics and back.",
                gradient: "linear-gradient(135deg, #059669 0%, #047857 100%)",
                delay: "0.1s",
              },
              {
                icon: FaShieldAlt,
                title: "Lab Test Arrangements",
                description:
                  "Seamless coordination of laboratory tests as required.",
                gradient: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                delay: "0.2s",
              },
            ].map((feature, index) => (
              <Col md={4} key={index}>
                <Card
                  className="h-100 border-0 rounded-4 overflow-hidden"
                  style={{
                    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
                    transform: "translateY(0)",
                    transition: "all 0.4s ease",
                    animationDelay: feature.delay,
                    animation: "fadeInUp 0.8s ease forwards",
                    backgroundColor: "#f0fdfa",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)"
                    e.currentTarget.style.boxShadow = "0 20px 60px rgba(0, 0, 0, 0.15)"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)"
                    e.currentTarget.style.boxShadow = "0 10px 40px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  <Card.Body className="p-5 text-center">
                    <div
                      className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center"
                      style={{
                        width: "80px",
                        height: "80px",
                        background: feature.gradient,
                        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
                      }}
                    >
                      <feature.icon size={32} className="text-white" />
                    </div>
                    <Card.Title className="h4 fw-bold mb-3" style={{ color: "#1f2937" }}>
                      {feature.title}
                    </Card.Title>
                    <Card.Text className="text-muted" style={{ lineHeight: "1.6" }}>
                      {feature.description}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="py-5" style={{ backgroundColor: "#f0fdfa" }}>
        <Container>
          <div className="text-center mb-5">
            <div
              className="d-inline-flex align-items-center px-4 py-2 rounded-pill mb-4"
              style={{
                background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
                color: "white",
              }}
            >
              <FaHeart className="me-2" />
              <span className="fw-medium">Our Purpose</span>
            </div>

            <h2 className="display-5 fw-bold mb-4" style={{ color: "#1f2937" }}>
              Vision & Mission
            </h2>
            <p className="fs-5 text-muted mb-0" style={{ maxWidth: "700px", margin: "0 auto" }}>
              Guiding principles that drive our commitment to exceptional healthcare services
            </p>
          </div>

          <Row className="g-5 align-items-stretch">
            {/* Vision Card */}
            <Col lg={6}>
              <Card
                className="h-100 border-0 rounded-4 overflow-hidden"
                style={{
                  boxShadow: "0 15px 50px rgba(0, 0, 0, 0.1)",
                  transform: "translateY(0)",
                  transition: "all 0.4s ease",
                  backgroundColor: "white",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)"
                  e.currentTarget.style.boxShadow = "0 25px 70px rgba(0, 0, 0, 0.15)"
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)"
                  e.currentTarget.style.boxShadow = "0 15px 50px rgba(0, 0, 0, 0.1)"
                }}
              >
                <Card.Body className="p-5">
                  <div className="text-center mb-4">
                    <div
                      className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center"
                      style={{
                        width: "90px",
                        height: "90px",
                        background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                        boxShadow: "0 15px 40px rgba(37, 99, 235, 0.3)",
                      }}
                    >
                      <FaEye size={36} className="text-white" />
                    </div>
                    <Card.Title className="h3 fw-bold mb-4" style={{ color: "#1f2937" }}>
                      Our Vision
                    </Card.Title>
                  </div>

                  <Card.Text
                    className="text-muted text-center"
                    style={{
                      lineHeight: "1.8",
                      fontSize: "1.1rem",
                      fontStyle: "italic",
                    }}
                  >
                    "To be the leading partner in patient-centric healthcare access, delivering seamless, safe, and
                    dignified transport and care coordination services that empower healthier communities."
                  </Card.Text>

                  <div className="text-center mt-4">
                    <div
                      className="d-inline-flex align-items-center px-4 py-2 rounded-pill"
                      style={{
                        background: "linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(29, 78, 216, 0.1) 100%)",
                        border: "1px solid rgba(37, 99, 235, 0.2)",
                      }}
                    >
                      <span className="fw-medium" style={{ color: "#2563eb" }}>
                        Leading Healthcare Access
                      </span>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Mission Card */}
            <Col lg={6}>
              <Card
                className="h-100 border-0 rounded-4 overflow-hidden"
                style={{
                  boxShadow: "0 15px 50px rgba(0, 0, 0, 0.1)",
                  transform: "translateY(0)",
                  transition: "all 0.4s ease",
                  backgroundColor: "white",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)"
                  e.currentTarget.style.boxShadow = "0 25px 70px rgba(0, 0, 0, 0.15)"
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)"
                  e.currentTarget.style.boxShadow = "0 15px 50px rgba(0, 0, 0, 0.1)"
                }}
              >
                <Card.Body className="p-5">
                  <div className="text-center mb-4">
                    <div
                      className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center"
                      style={{
                        width: "90px",
                        height: "90px",
                        background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
                        boxShadow: "0 15px 40px rgba(5, 150, 105, 0.3)",
                      }}
                    >
                      <FaBullseye size={36} className="text-white" />
                    </div>
                    <Card.Title className="h3 fw-bold mb-4" style={{ color: "#1f2937" }}>
                      Our Mission
                    </Card.Title>
                  </div>

                  <Card.Text
                    className="text-muted text-center"
                    style={{
                      lineHeight: "1.8",
                      fontSize: "1.1rem",
                      fontStyle: "italic",
                    }}
                  >
                    "We are committed to enhancing patient well-being by providing reliable appointment management,
                    professional escort services, and secure transportation. Through compassionate support and
                    operational excellence, we ensure every patient's healthcare journey is smooth, stress-free, and
                    dignified."
                  </Card.Text>

                  <div className="text-center mt-4">
                    <div
                      className="d-inline-flex align-items-center px-4 py-2 rounded-pill"
                      style={{
                        background: "linear-gradient(135deg, rgba(5, 150, 105, 0.1) 0%, rgba(4, 120, 87, 0.1) 100%)",
                        border: "1px solid rgba(5, 150, 105, 0.2)",
                      }}
                    >
                      <span className="fw-medium" style={{ color: "#059669" }}>
                        Compassionate Excellence
                      </span>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Core Values */}
          <div className="text-center mt-5 pt-4">
            <h3 className="h4 fw-bold mb-4" style={{ color: "#1f2937" }}>
              Our Core Values
            </h3>
            <Row className="g-3 justify-content-center">
              {[
                { text: "Patient-Centric Care", color: "#2563eb" },
                { text: "Dignity & Respect", color: "#059669" },
                { text: "Safety & Security", color: "#0891b2" },
                { text: "Operational Excellence", color: "#dc2626" },
              ].map((value, index) => (
                <Col key={index} xs="auto">
                  <div
                    className="px-4 py-2 rounded-pill fw-medium"
                    style={{
                      background: `linear-gradient(135deg, ${value.color}15 0%, ${value.color}10 100%)`,
                      border: `1px solid ${value.color}30`,
                      color: value.color,
                      transition: "all 0.3s ease",
                    }}
                  >
                    {value.text}
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
      </section>

      {/* Testimonials Section */}
      <section className="py-5" style={{ backgroundColor: "white" }}>
        <Container>
          <div className="text-center mb-5">
            <h2 className="display-5 fw-bold mb-4" style={{ color: "#1f2937" }}>
              What Our Patients Say
            </h2>
            <p className="fs-5 text-muted">Real stories from real patients</p>
          </div>

          <Row className="g-4">
            {[
              {
                name: "Muhammad Abdullah",
                rating: 5,
                comment:
                  "Amazing service! They helped me get an urgent appointment when I needed it most. Highly recommended!",
                avatar: "MA",
                // role: "Patient since 2023",
              },
              {
                name: "Sara Khan",
                rating: 5,
                comment: "Professional and efficient. The booking process was seamless and the doctor was excellent.",
                avatar: "SK",
                // role: "Patient since 2022",
              },
              {
                name: "Sheikh Raza",
                rating: 5,
                comment: "24/7 availability is a game-changer. They connected me with a specialist at midnight!",
                avatar: "SR",
                // role: "Patient since 2024",
              },
            ].map((testimonial, index) => (
              <Col md={4} key={index}>
                <Card
                  className="h-100 border-0 rounded-4"
                  style={{
                    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
                    transform: "translateY(0)",
                    transition: "all 0.3s ease",
                    backgroundColor: "#f0fdfa",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)"
                    e.currentTarget.style.boxShadow = "0 15px 50px rgba(0, 0, 0, 0.12)"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)"
                    e.currentTarget.style.boxShadow = "0 10px 40px rgba(0, 0, 0, 0.08)"
                  }}
                >
                  <Card.Body className="p-4">
                    <div className="d-flex mb-3">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <FaStar key={i} style={{ color: "#f59e0b" }} className="me-1" />
                      ))}
                    </div>
                    <Card.Text className="text-muted mb-4 fst-italic" style={{ lineHeight: "1.6" }}>
                      "{testimonial.comment}"
                    </Card.Text>
                    <div className="d-flex align-items-center">
                      <div
                        className="rounded-circle me-3 d-flex align-items-center justify-content-center fw-bold text-white"
                        style={{
                          width: "50px",
                          height: "50px",
                          background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                        }}
                      >
                        {testimonial.avatar}
                      </div>
                      <div>
                        <div className="fw-bold" style={{ color: "#1f2937" }}>
                          {testimonial.name}
                        </div>
                        {/* <small className="text-muted">{testimonial.role}</small> */}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <Footer/>

      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
          }
          70% {
            box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
          }
        }
      `}</style>

      {/* Driver Registration Modal */}
      <Modal 
        show={showDriverModal} 
        onHide={() => setShowDriverModal(false)}
        size="lg"
        centered
      >
        <Modal.Header 
          closeButton 
          style={{
            background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
            color: "white"
          }}
        >
          <Modal.Title className="d-flex align-items-center">
            <FaCar className="me-2" />
            Driver Registration
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form onSubmit={handleDriverSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Full Name *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your full name"
                    value={driverForm.name}
                    onChange={(e) => setDriverForm({...driverForm, name: e.target.value})}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Car Name *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter car name"
                    value={driverForm.car_name}
                    onChange={(e) => setDriverForm({...driverForm, car_name: e.target.value})}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Engine Capacity *</Form.Label>
                  <Form.Select
                    value={driverForm.engine_capacity}
                    onChange={(e) => setDriverForm({...driverForm, engine_capacity: e.target.value})}
                    required
                  >
                    <option value="">Select engine capacity</option>
                    <option value="660cc">660cc</option>
                    <option value="1000cc">1000cc</option>
                    <option value="1300cc">1300cc</option>
                    <option value="1500cc">1500cc</option>
                    <option value="1800cc">1800cc</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Car Model Year *</Form.Label>
                  <Form.Control
                    type="number"
                    min={driverForm.engine_capacity === '660cc' ? 1990 : 
                         driverForm.engine_capacity === '1000cc' ? 1995 : 
                         driverForm.engine_capacity === '1300cc' ? 2000 : 
                         driverForm.engine_capacity === '1500cc' ? 2005 : 
                         driverForm.engine_capacity === '1800cc' ? 2010 : 1990}
                    max="2024"
                    placeholder="Enter car model year"
                    value={driverForm.car_model_year}
                    onChange={(e) => setDriverForm({...driverForm, car_model_year: e.target.value})}
                    required
                  />
                  <Form.Text className="text-muted">
                    {driverForm.engine_capacity && 
                      `Year range for ${driverForm.engine_capacity}: ${
                        driverForm.engine_capacity === '660cc' ? '2020-2025' : 
                        driverForm.engine_capacity === '1000cc' ? '2018-2025' : 
                        driverForm.engine_capacity === '1300cc' ? '2018-2025' : 
                        driverForm.engine_capacity === '1500cc' ? '2015-2025' : 
                        driverForm.engine_capacity === '1800cc' ? '2015-2025' : '2020-2024'
                      }`
                    }
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>

            <Row>
               <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">Phone Number *</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="03XXXXXXXXX"
                      value={driverForm.phone_number}
                      onChange={(e) => setDriverForm({ ...driverForm, phone_number: e.target.value })}
                      required
                    />
                    <Form.Text className="text-muted">
                      Format: 03XXXXXXXXX
                    </Form.Text>
                  </Form.Group>
                </Col>
              {/* <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Images </Form.Label>
                  <Form.Control
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={(e) => setDriverForm({...driverForm, images: Array.from(e.target.files)})}
                    
                  />
                  <Form.Text className="text-muted">
                    Upload up to 5 images of your vehicle. Accepted formats: JPG, PNG, GIF
                  </Form.Text>
                    
                    {/* Image Preview *
                    {driverForm.images.length > 0 && (
                      <div className="mt-3">
                        <Form.Label className="fw-bold">Selected Images:</Form.Label>
                        <div className="d-flex flex-wrap gap-2 mt-2">
                          {driverForm.images.map((image, index) => (
                            <div key={index} className="position-relative">
                              <img
                                src={URL.createObjectURL(image)}
                                alt={`Preview ${index + 1}`}
                                style={{
                                  width: '80px',
                                  height: '80px',
                                  objectFit: 'cover',
                                  borderRadius: '8px',
                                  border: '2px solid #dee2e6'
                                }}
                              />
                              <Button
                                variant="danger"
                                size="sm"
                                className="position-absolute top-0 end-0"
                                style={{
                                  transform: 'translate(50%, -50%)',
                                  borderRadius: '50%',
                                  width: '24px',
                                  height: '24px',
                                  padding: '0',
                                  fontSize: '12px'
                                }}
                                onClick={() => {
                                  const newImages = driverForm.images.filter((_, i) => i !== index);
                                  setDriverForm({...driverForm, images: newImages});
                                }}
                              >
                                ×
                              </Button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </Form.Group>
                </Col> */}
            </Row>

            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button
                variant="outline-secondary"
                onClick={() => setShowDriverModal(false)}
                className="px-4"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={loading}
                style={{
                  background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                  border: "none"
                }}
                className="px-4"
              >
                {loading ? 'Registering...' : 'Register as Driver'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
  show={showAppointmentModal}
  onHide={() => setShowAppointmentModal(false)}
  size="lg"
  centered
>
  <Modal.Header closeButton>
    <Modal.Title style={{ color: "#0891b2" }}>Book an Appointment</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <PatientRegister setShowAppointmentModal={setShowAppointmentModal} />
  </Modal.Body>
</Modal>

    </div>
  )
}
